import { all } from "redux-saga/effects";
import authSaga from "./modules/auth/saga";
import subscriptionSaga from "./modules/subscriptionWeb/saga";
import subscriptionAdminSaga from "./modules/subscriptionAdmin/saga";
import subscriptionOrderSaga from "./modules/ordersAdmin/saga";
import companySaga from "./modules/company/saga";
import couponSaga from "./modules/coupon/saga";
import dashboardSaga from "./modules/dashboard/saga";
import userSaga from "./modules/users/saga";
import CorporateSaga from './modules/CorporatePlan/saga';
import SendNotificationsSaga from "./modules/SendNotifications/saga";

export default function* rootSagas() {
  yield all([
    authSaga(),
    subscriptionSaga(),
    subscriptionAdminSaga(),
    subscriptionOrderSaga(),
    companySaga(),
    couponSaga(),
    dashboardSaga(),
    userSaga(),
    CorporateSaga(),
    SendNotificationsSaga(),
  ]);
}
